import React from 'react';

import styled from '@emotion/styled';

import PageHeader from '../../../components/Layout/PageHeader';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import DashboardChart from './DashboardChart';
import DashboardStats from './DashboardStats';
import TableAndBarChart from './TableAndBarChart';
import TotalIncidentReport from './TotalIncidentReport';

const Dashboard = () => {
  return (
    <Page title='Logirate | Dashboard'>
      <PageLayout>
        <Container>
          <PageHeader
            title='Overview'
            className='borderless no-bottom-padding'
          />
          <DashboardStats />
          <DashboardChart />
          <TableAndBarChart />
          <TotalIncidentReport />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default Dashboard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;
